import { InfiniteClient } from "./infinite-client";
import { PAYLOAD_SYMBOL } from "./resource-client";
import type { IQuery } from "./utils";

export type WithPayload<T> = T & {
  [PAYLOAD_SYMBOL]: any;
};

export abstract class CursorClient<
  Model,
  Identifier = string,
  QueryParams extends IQuery = IQuery,
> extends InfiniteClient<Model, Identifier, QueryParams> {
  /**
   * for paging/infinite queries, extract the next cursor from the previous payload
   * @param {Object} previousResult
   * @returns {IQuery | undefined}
   */
  protected getNextQuery(
    previousResult: WithPayload<Model[]>
  ): IQuery | undefined {
    const cursor = previousResult[PAYLOAD_SYMBOL]?.next;
    return cursor ? { cursor } : undefined;
  }
}

export default CursorClient;
